var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FolderTagPreview',{attrs:{"id":_vm.item.injected.fileid,"name":_vm.item.injected.basename,"path":_vm.item.injected.filename,"file-list":_vm.previewFiles}})}
var staticRenderFns = []

export { render, staticRenderFns }